// Which code a flagged-order line shows for its product.
//
// Amazon catalogue SKUs are the ASIN plus a unit suffix ("B0D7HGN762/1"),
// so printing item.sku shows the leader an ASIN. The number actually on
// the unit they are holding is the FNSKU, and for those SKUs products.
// barcode holds it (checked against Mongo completemanifests.FNSku on live
// Pembroke flagged orders 2026-10-15: every line matched, including
// commingled stock where the FNSKU is the ASIN itself). So for an
// ASIN-shaped SKU we show the barcode; every other catalogue keeps its
// SKU, because there the barcode is an EAN and the SKU is what staff know.
//
// Asked for by Alex, 2026-10-15: "display the FNSKU not the ASIN".
export const ASIN_SKU_RE = /^B0[A-Z0-9]{8}\/\d+$/;

export const displayItemCode = (sku: string, barcode: string | null | undefined): string => {
    const code = (barcode ?? "").trim();
    return ASIN_SKU_RE.test(sku) && code ? code : sku;
};
